// Complete the Look cards. Each card adds one variant.
//
// This script is referenced from more than one layout and can be re-injected
// by Quick View. The guard skips a second evaluation so the class is not
// declared twice.

if (window.__crossSellManagerLoaded) {
	// already initialized on this page
} else {
	window.__crossSellManagerLoaded = true

	class CrossSellManager {
		constructor() {
			this.selectors = {
				fallbackContainer: ".product-recommendation-cross-sells-fallback",
				recommendationsContainer:
					".product-recommendation-cross-sells-container:not(.product-recommendation-cross-sells-fallback)",
				productRecommendations: "product-recommendations",
			}
			this.timeouts = {
				fallbackDetection: 1500,
				cartDrawerOpen: 500,
			}
		}

		init() {
			this.applyGenderContextImages()
			this.bindEvents()

			if (document.querySelector(".product-recommendation-cross-sells-metafield")) return

			this.setupRecommendationObserver()
			this.setupFallbackTimeout()
		}

		applyGenderContextImages() {
			const params = new URLSearchParams(window.location.search)
			const gender = params.has("mens") ? "mens" : params.has("womens") ? "womens" : null
			if (!gender) return
			const datasetKey = gender === "mens" ? "mensSrc" : "womensSrc"
			document
				.querySelectorAll(`.product-recommendation-cross-sells-container img[data-${gender}-src]`)
				.forEach((img) => {
					if (!img.dataset[datasetKey]) return
					img.src = img.dataset[datasetKey]
					img.removeAttribute("srcset")
				})
		}

		bindEvents() {
			document.addEventListener("click", (event) => {
				const option = event.target.closest(".cross-sell-card__option")
				if (option) {
					event.preventDefault()
					this.selectOption(option)
					return
				}

				const toggle = event.target.closest(".cross-sell-card__toggle")
				if (toggle) {
					event.preventDefault()
					this.toggleMenu(toggle)
					return
				}

				document.querySelectorAll('.cross-sell-card__toggle[aria-expanded="true"]').forEach((openToggle) => {
					if (!openToggle.closest(".cross-sell-card").contains(event.target)) {
						this.closeMenu(openToggle)
					}
				})
			})

			document.addEventListener("keydown", (event) => {
				const toggle = event.target.closest?.(".cross-sell-card__toggle")
				const option = event.target.closest?.(".cross-sell-card__option")
				if (!toggle && !option) return

				if (event.key === "Escape") {
					const card = event.target.closest(".cross-sell-card")
					const cardToggle = card?.querySelector(".cross-sell-card__toggle")
					if (cardToggle?.getAttribute("aria-expanded") === "true") {
						event.preventDefault()
						this.closeMenu(cardToggle)
						cardToggle.focus()
					}
					return
				}

				if (toggle && (event.key === "ArrowDown" || event.key === "ArrowUp")) {
					event.preventDefault()
					this.openMenu(toggle)
					this.focusOption(toggle, event.key === "ArrowUp" ? "last" : "first")
					return
				}

				if (!option) return
				if (event.key !== "ArrowDown" && event.key !== "ArrowUp" && event.key !== "Home" && event.key !== "End") return
				event.preventDefault()
				const cardToggle = option.closest(".cross-sell-card")?.querySelector(".cross-sell-card__toggle")
				if (!cardToggle) return
				const enabled = this.enabledOptions(cardToggle)
				const index = enabled.indexOf(option)
				if (event.key === "Home") {
					enabled[0]?.focus()
					return
				}
				if (event.key === "End") {
					enabled[enabled.length - 1]?.focus()
					return
				}
				const next = event.key === "ArrowDown" ? index + 1 : index - 1
				enabled[next]?.focus()
			})

			document.addEventListener("submit", (event) => {
				if (!event.target.classList?.contains("cross-sell-card")) return
				event.preventDefault()
				event.stopPropagation()
				this.addCard(event.target)
			})

			// Follow the size picked on the page product. product.js fires this on
			// every variant change, so the cards stay in step with the main picker.
			document.addEventListener("product:variant-change", (event) => {
				this.syncSizeFromPageVariant(event.detail?.variant)
			})
		}

		syncSizeFromPageVariant(variant) {
			if (!variant || !Array.isArray(variant.options)) return
			this.syncSizeFromPage((card) => {
				const position = Number(card.dataset.pageSizePosition)
				return position ? variant.options[position - 1] : null
			})
		}

		// Cards fetched from /recommendations render without the page product, so
		// read the size straight from the main product's size picker instead.
		syncSizeFromPagePicker() {
			const picker = document.querySelector(
				'.product-information fieldset[data-handle*="size"] input[type="radio"]:checked, .product-information fieldset[data-handle*="size"] select',
			)
			if (!picker?.value) return
			this.syncSizeFromPage(() => picker.value)
		}

		syncSizeFromPage(sizeForCard) {
			document.querySelectorAll('.cross-sell-card[data-choice-kind="size"]').forEach((card) => {
				if (card.dataset.userChoice === "true") return
				const size = sizeForCard(card)
				if (!size) return
				const sizeLower = String(size).trim().toLowerCase()
				const option = Array.from(card.querySelectorAll(".cross-sell-card__option:not(:disabled)")).find(
					(item) => (item.dataset.label || "").trim().toLowerCase() === sizeLower,
				)
				if (option) {
					if (option.getAttribute("aria-selected") !== "true") this.selectOption(option, { fromPage: true })
					return
				}
				// The page size is sold out on this card: clear the stale size rather than
				// leave a different one quietly selected.
				this.clearSelection(card)
			})
		}

		clearSelection(card) {
			const input = card.querySelector("[data-variant-input]")
			const label = card.querySelector("[data-selected-label]")
			if (input) input.value = ""
			if (label && label.dataset.placeholder) label.textContent = label.dataset.placeholder
			card.querySelectorAll(".cross-sell-card__option").forEach((item) => item.setAttribute("aria-selected", "false"))
			this.resetAdded(card)
		}

		toggleMenu(toggle) {
			if (toggle.getAttribute("aria-expanded") === "true") {
				this.closeMenu(toggle)
				return
			}
			this.openMenu(toggle)
		}

		openMenu(toggle) {
			document.querySelectorAll('.cross-sell-card__toggle[aria-expanded="true"]').forEach((openToggle) => {
				if (openToggle !== toggle) this.closeMenu(openToggle)
			})
			const menu = document.getElementById(toggle.getAttribute("aria-controls"))
			if (!menu) return
			menu.hidden = false
			toggle.setAttribute("aria-expanded", "true")
			toggle.closest(".cross-sell-card")?.classList.add("tw:z-30")
			// On desktop the product info column is position: sticky, which makes it a
			// stacking context. A menu on the last card hangs below that column, where
			// later sections (painted in tree order) would cover it. Lift the column
			// only while a menu is open.
			toggle.closest(".product-information--inner")?.classList.add("tw:z-10")
			this.clearChoiceError(toggle.closest(".cross-sell-card"))
		}

		closeMenu(toggle) {
			const menu = document.getElementById(toggle.getAttribute("aria-controls"))
			if (menu) menu.hidden = true
			toggle.setAttribute("aria-expanded", "false")
			toggle.closest(".cross-sell-card")?.classList.remove("tw:z-30")
			toggle.closest(".product-information--inner")?.classList.remove("tw:z-10")
		}

		enabledOptions(toggle) {
			const menu = document.getElementById(toggle.getAttribute("aria-controls"))
			if (!menu) return []
			return Array.from(menu.querySelectorAll(".cross-sell-card__option:not(:disabled)"))
		}

		focusOption(toggle, which) {
			const enabled = this.enabledOptions(toggle)
			const option = which === "last" ? enabled[enabled.length - 1] : enabled[0]
			option?.focus()
		}

		selectOption(option, { fromPage = false } = {}) {
			if (option.disabled) return
			const card = option.closest(".cross-sell-card")
			if (!card) return
			// A size the shopper picks on the card wins over later page-size changes
			if (!fromPage) card.dataset.userChoice = "true"
			const input = card.querySelector("[data-variant-input]")
			const label = card.querySelector("[data-selected-label]")
			const price = card.querySelector("[data-price]")
			const compare = card.querySelector("[data-compare]")
			const image = card.querySelector("img")
			const toggle = card.querySelector(".cross-sell-card__toggle")

			if (input) input.value = option.dataset.variantId || ""
			if (label) label.textContent = option.dataset.label || ""
			if (price) {
				price.textContent = option.dataset.price || ""
				price.classList.toggle("tw:font-bold", Boolean(option.dataset.compare))
			}
			if (compare) {
				compare.textContent = option.dataset.compare || ""
				compare.hidden = !option.dataset.compare
			}
			if (image && option.dataset.image) this.updateImage(image, option.dataset.image)

			card.querySelectorAll(".cross-sell-card__option").forEach((item) => {
				item.setAttribute("aria-selected", item === option ? "true" : "false")
			})

			this.clearChoiceError(card)
			this.resetAdded(card)
			if (toggle) {
				this.closeMenu(toggle)
				if (!fromPage) toggle.focus()
			}
		}

		updateImage(image, variantImage) {
			const params = new URLSearchParams(window.location.search)
			const genderSrc = params.has("mens")
				? image.dataset.mensSrc
				: params.has("womens")
					? image.dataset.womensSrc
					: null
			image.src = genderSrc || variantImage
			if (genderSrc) image.removeAttribute("srcset")
		}

		showChoiceError(card) {
			const toggle = card.querySelector(".cross-sell-card__toggle")
			const error = card.querySelector("[data-error]")
			if (toggle) {
				toggle.setAttribute("data-invalid", "")
				toggle.setAttribute("aria-invalid", "true")
			}
			if (error) error.hidden = false
		}

		clearChoiceError(card) {
			if (!card) return
			const toggle = card.querySelector(".cross-sell-card__toggle")
			const error = card.querySelector("[data-error]")
			if (toggle) {
				toggle.removeAttribute("data-invalid")
				toggle.removeAttribute("aria-invalid")
			}
			if (error) error.hidden = true
		}

		resetAdded(card) {
			const button = card.querySelector(".cross-sell-card__add")
			const text = button?.querySelector(".cross-sell-card__add-text")
			if (!button || !text || button.dataset.added !== "true") return
			text.textContent = text.dataset.labelAdd || text.textContent
			delete button.dataset.added
		}

		addCard(card) {
			const button = card.querySelector(".cross-sell-card__add")
			const input = card.querySelector("[data-variant-input]")
			if (!button || button.classList.contains("loading")) return

			if (card.dataset.requiresChoice === "true" && !input?.value) {
				this.showChoiceError(card)
				card.querySelector(".cross-sell-card__toggle")?.focus()
				return
			}

			if (!input?.value) return

			this.setLoading(button)
			this.addSingleItem(input.value, card)
				.then((data) => {
					this.dispatchCartItemAddedEvent(data)
					if (data.sections) this.renderContents(data)
					this.showAdded(button)
					this.openCartDrawer()
				})
				.catch((error) => {
					this.clearLoading(button)
					const message = card.querySelector("[data-error]")
					if (message) {
						message.textContent = error.message || message.textContent
						message.hidden = false
					}
				})
		}

		setLoading(button) {
			button.classList.add("loading")
			button.setAttribute("aria-busy", "true")
			const text = button.querySelector(".cross-sell-card__add-text")
			if (text) text.hidden = true
		}

		clearLoading(button) {
			button.classList.remove("loading")
			button.removeAttribute("aria-busy")
			const text = button.querySelector(".cross-sell-card__add-text")
			if (text) text.hidden = false
		}

		showAdded(button) {
			this.clearLoading(button)
			const text = button.querySelector(".cross-sell-card__add-text")
			if (text) text.textContent = text.dataset.labelAdded || text.textContent
			button.dataset.added = "true"
		}

		openCartDrawer() {
			if (typeof dispatchCustomEvent === "function") {
				dispatchCustomEvent("cart:refresh")
			}
			setTimeout(() => {
				document.getElementById("cart-drawer-toggle")?.click()
			}, this.timeouts.cartDrawerOpen)
		}

		isThemeCartAvailable() {
			return typeof theme !== "undefined" && theme.routes && theme.routes.cart_add_url
		}

		async addSingleItem(variantId, card) {
			if (!this.isThemeCartAvailable()) {
				throw new Error("Theme cart utilities not available")
			}

			const formData = new FormData()
			formData.append("id", variantId)
			formData.append("quantity", "1")
			formData.append(
				"sections",
				this.getSectionsToRender()
					.map((section) => section.section)
					.join(",")
			)
			formData.append("sections_url", window.location.pathname)
			const attribution = card.querySelector('input[name="properties[_attribution]"]')
			if (attribution) formData.append("properties[_attribution]", attribution.value)

			const response = await fetch(theme.routes.cart_add_url, {
				method: "POST",
				headers: {
					"X-Requested-With": "XMLHttpRequest",
					Accept: "application/json",
				},
				body: formData,
			})

			const data = await response.json()
			if (!response.ok || data.status) {
				throw new Error(data.description || data.message || "Failed to add item to cart")
			}
			return data
		}

		dispatchCartItemAddedEvent(data) {
			const product = Object.prototype.hasOwnProperty.call(data, "items") ? data.items[0] : data
			if (typeof dispatchCustomEvent === "function") {
				dispatchCustomEvent("cart:item-added", { product })
				return
			}
			document.documentElement.dispatchEvent(
				new CustomEvent("cart:item-added", {
					detail: { product },
					bubbles: true,
				})
			)
		}

		getSectionsToRender() {
			return [
				{ id: "Cart", section: "main-cart", selector: ".thb-cart-form" },
				{ id: "Cart-Drawer", section: "cart-drawer", selector: ".cart-drawer" },
				{ id: "cart-drawer-toggle", section: "cart-bubble", selector: ".thb-item-count" },
			]
		}

		renderContents(parsedState) {
			this.getSectionsToRender().forEach((section) => {
				const root = document.getElementById(section.id)
				if (!root || !parsedState.sections || !parsedState.sections[section.section]) return
				const elementToReplace = root.querySelector(section.selector) || root
				elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector)

				if (section.id === "Cart-Drawer") {
					const cartDrawer = document.getElementById("Cart-Drawer")
					cartDrawer?.notesToggle?.()
					cartDrawer?.removeProductEvent?.()
				}
				if (section.id === "Cart" && typeof Cart !== "undefined") {
					new Cart().renderContents(parsedState)
				}
			})
		}

		getSectionInnerHTML(html, selector = ".shopify-section") {
			const doc = new DOMParser().parseFromString(html, "text/html")
			const element = doc.querySelector(selector)
			return element ? element.innerHTML : ""
		}

		getRecommendationsContainer() {
			return document.querySelector(this.selectors.recommendationsContainer)
		}

		setupRecommendationObserver() {
			const element = document.querySelector(this.selectors.productRecommendations)
			if (!element) return
			const observer = new MutationObserver(() => {
				if (!element.classList.contains("product-recommendations--loaded")) return
				this.resolveFetchedRecommendations()
			})
			observer.observe(element, { attributes: true, attributeFilter: ["class"] })
		}

		setupFallbackTimeout() {
			setTimeout(() => this.resolveFetchedRecommendations(), this.timeouts.fallbackDetection)
		}

		resolveFetchedRecommendations() {
			const recommendations = this.getRecommendationsContainer()
			const fallback = document.querySelector(this.selectors.fallbackContainer)
			const hasCards = recommendations?.querySelector(".cross-sell-card")
			if (hasCards) {
				fallback?.classList.add("tw:hidden")
				fallback?.classList.remove("tw:flex")
				this.applyGenderContextImages()
				this.syncSizeFromPagePicker()
				return
			}
			if (!fallback?.querySelector(".cross-sell-card")) return
			recommendations?.classList.add("tw:hidden")
			fallback.classList.remove("tw:hidden")
			fallback.classList.add("tw:flex")
			this.applyGenderContextImages()
		}
	}

	// Quick View injects this script long after DOMContentLoaded has fired, so
	// start immediately in that case instead of waiting for an event that
	// will not come.
	const startCrossSellManager = () => {
		const crossSellManager = new CrossSellManager()
		crossSellManager.init()
	}
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", startCrossSellManager)
	} else {
		startCrossSellManager()
	}
}
